'use client';
import { useUserStore } from '@/store/auth';
import { Button } from '@mui/material';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';

function LoginButton() {
  const auth = useUserStore(state => state.auth);
  const [isClientReady, setIsClientReady] = useState(false);

  useEffect(() => {
    setIsClientReady(true);
  }, []);
  return (
    <Button
      variant="contained"
      fullWidth
      sx={{
        fontSize: { xs: 24, sm: 26, md: 28 },
      }}
      component={Link}
      href="/panel">
      {isClientReady && auth() ? 'پنل کاربری' : 'ورود و ثبت نام'}
    </Button>
  );
}

export default LoginButton;
